var render = function render(){var _vm=this,_c=_vm._self._c;return _c('textarea',{class:_vm.mergedClasses,attrs:{"id":_vm.id,"dusk":_vm.id,"rows":_vm.rows,"placeholder":_vm.placeholder,"tabindex":_vm.tabindex,"readonly":_vm.readonly},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event.target.value)}}},[_vm._v("        "+_vm._s(_vm.value)+"\n    ")])
}
var staticRenderFns = []

export { render, staticRenderFns }